import { render } from "./main-404.vue?vue&type=template&id=16796e88&scoped=true"
import script from "./main-404.vue?vue&type=script&lang=js"
export * from "./main-404.vue?vue&type=script&lang=js"

import "./main-404.vue?vue&type=style&index=0&id=16796e88&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16796e88"]])

export default __exports__